import { Spinner } from "src/core/components/custom-ui/spinner";

export const SpinnerFullPage = () => {
  return (
    <div className="h-full flex justify-center items-center w-full">
      <Spinner size="2xl" />
    </div>
  );
};
